import { render } from "./ProjectsPage.vue?vue&type=template&id=5e13b2a2"
const script = {}

import "./ProjectsPage.vue?vue&type=style&index=0&id=5e13b2a2&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__